import React from "react";
import AddEditUserWidget from "./AddEditUserWidget";

const CreateUser = () => {
  return (
    <React.Fragment>
      <AddEditUserWidget />
    </React.Fragment>
  );
};

export default CreateUser;
